import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../hooks/useCookieConsent';

/**
 * Cookie consent banner.
 *
 * Shown until the user makes a decision. Analytics stays off — and the GA4
 * SDK stays unloaded — until "Akceptuję" is pressed, so accept and reject are
 * given equal visual weight and neither is preselected.
 */
const CookieConsentBanner: React.FC = () => {
  const { consent, accept, decline } = useCookieConsent();

  if (consent !== null) {
    return null;
  }

  return (
    <div
      role="region"
      aria-label="Zgoda na pliki cookies"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white shadow-2xl"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-4 px-4 py-5 sm:px-6 md:flex-row md:items-center md:justify-between">
        <div className="text-sm text-gray-700">
          <p className="mb-1 font-semibold text-gray-900">Pliki cookies</p>
          <p>
            Używamy niezbędnych plików cookies, aby aplikacja działała
            poprawnie. Za Twoją zgodą korzystamy również z Google Analytics, aby
            liczyć odwiedziny i ulepszać aplikację. Szczegóły znajdziesz w{' '}
            <Link
              to="/privacy"
              className="font-medium text-orange-700 underline hover:text-orange-800"
            >
              Polityce Prywatności
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={decline}
            className="rounded-lg border-2 border-gray-300 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50"
          >
            Odrzuć
          </button>
          <button
            type="button"
            onClick={accept}
            className="rounded-lg bg-orange-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-700"
          >
            Akceptuję
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
